// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__36FL1","pendingPaymentIcon":"CalendarEvent_pendingPaymentIcon__3oPpo","gfeWrapper":"CalendarEvent_gfeWrapper__15vM_"};